import {
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  TextField
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import AppButton from '../../../commonComponents/AppButton'
import { TextBold, TextRegular } from '../../../commonComponents/TextStyling'
import { useTheme } from '@mui/styles'
import TextEditor from '../../../commonComponents/TextEditor'
import { isEmpty, showToast } from '../../../utils/AppHelper'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import { styled } from '@mui/material/styles'
import serverData from '../../../api/ServerData'
import { useLocation } from 'react-router-dom'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 5,
  p: 2,
  width: '70%',
  height: 'auto'
}

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
})

export default function UpdateQuestionModal ({ data }) {
  var { open, item, type, onReload, onClose } = data
  const theme = useTheme()

  const [coverSummary, setCoverSummary] = useState('')
  const [candidateFirstName, setCandidateFirstName] = useState('')
  const [candidateLastName, setCandidateLastName] = useState('')
  const [candidatePhone, setCandidatePhone] = useState('')
  const [candidateEmail, setCandidateEmail] = useState('')

  const [preScreenQues, setPreScreenQues] = useState([])

  const [inputSkills, setInputSkills] = useState('')
  const [skillRequired, setSkillRequired] = useState([])

  const [resume, setResume] = useState(item?.resumePath)
  const [coverLetter, setCoverLetter] = useState(null)

  const [loading, setLoading] = useState(false)

  const location = useLocation()
  const query = new URLSearchParams(location.search)
  const token = query.get('token')

  useEffect(function () {
    setCoverSummary(item?.coverSummary)
    setCandidateFirstName(item?.candidateFirstName)
    setCandidateLastName(item?.candidateLastName)
    setCandidatePhone(item?.candidatePhone)
    setPreScreenQues([...item?.preScreenQuestions])
    setSkillRequired([...item.skillRequired.split(',')])
    setCandidateEmail(item.candidateEmail)
  }, [])

  const [formError, setFormError] = useState({})
  const validateForm = () => {
    const error = {}

    if (isEmpty(candidateFirstName)) {
      error.candidateFirstName = 'Please enter candidate first name.'
    }
    if (isEmpty(candidateLastName)) {
      error.candidateLastName = 'Please enter candidate last name.'
    }
    if (isEmpty(candidatePhone)) {
      error.candidatePhone = 'Please enter candidate phone number.'
    }

    if (isEmpty(resume)) {
      error.resume = 'Please provide resume.'
    }

    if (preScreenQues.length > 0) {
      for (let index = 0; index < preScreenQues.length; index++) {
        const element = preScreenQues[index]
        if (isEmpty(element.answer)) {
          if (!error.hasOwnProperty('preScreenQues')) {
            error.preScreenQues = {}
          }
          error.preScreenQues[index] = {
            answer: 'Please enter an answer'
          }
        }
      }
    }
    setFormError(error)
    return Object.keys(error).length === 0
  }

  const handleAnswerChange = (index, value) => {
    const questions = [...preScreenQues]
    questions[index].answer = value
    setPreScreenQues(questions)
  }

  const handleUpdate = () => {
    if (validateForm()) {
      setLoading(true)
      var formData = new FormData()
      formData.append('applicationId', item?.applicationId)
      formData.append('jobId', item.jobId)
      formData.append('candidateFirstName', candidateFirstName)
      formData.append('candidateLastName', candidateLastName)
      formData.append('candidateEmail', candidateEmail)
      formData.append('candidatePhone', candidatePhone)
      if (resume?.name) {
        formData.append('resume', resume)
      }
      if (coverLetter?.name) {
        formData.append('coverletter', coverLetter)
      }
      if (coverSummary) {
        formData.append('coverSummary', coverSummary)
      }
      formData.append(
        'prescreenQue',
        preScreenQues.length > 0 ? JSON.stringify(preScreenQues) : ''
      )
      formData.append('token', token)

      serverData.candidateUpdateApplication(
        formData,
        data => {
          if (data) {
            showToast(data.message, false)
            onClose()
            onReload()
          } else {
            showToast(data.message)
          }
          setLoading(false)
        },
        error => {
          setLoading(false)
          showToast(error.statusText)
        }
      )
    }
  }

  const handleResumeChange = e => {
    const error = {}
    const file = e.target.files[0]
    const acceptFileType = [
      'application/pdf',
      'application/msword',
      'text/plain',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ]

    if (file && acceptFileType.includes(file.type)) {
      setResume(file)
    } else {
      error.resume = 'Please provide resume in pdf, word or text format'
      setResume(null)
    }
    setFormError(error)
  }

  const handleCoverLetterChange = e => {
    const error = {}
    const file = e.target.files[0]
    const acceptFileType = [
      'application/pdf',
      'application/msword',
      'text/plain',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ]

    if (file && acceptFileType.includes(file.type)) {
      setCoverLetter(file)
    } else {
      error.resume = 'Please provide cover letter in pdf, word or text format'
      setCoverLetter(null)
    }
    setFormError(error)
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Grid container style={{ display: 'flex' }}>
          <Grid item xs={12}>
            {type === 'coverSummary' && (
              <TextBold style={{ fontSize: '16px' }}>Cover letter</TextBold>
            )}
            {type === 'candidateDetails' && (
              <TextBold style={{ fontSize: '16px' }}>
                Candidate details edit
              </TextBold>
            )}
            {type === 'preScreen' && (
              <TextBold style={{ fontSize: '16px' }}>
                Pre screen questions edit
              </TextBold>
            )}
            {type === 'skills' && (
              <TextBold style={{ fontSize: '16px' }}>
                Skills & Expertise
              </TextBold>
            )}
          </Grid>

          {type === 'coverSummary' && (
            <Grid item xs={12}>
              <FormControl
                margin='normal'
                style={{ width: '90ch' }}
                error={formError.coverSummary}
              >
                <TextRegular style={{ color: theme.palette.text.secondary }}>
                  Tell the hiring manager why you are a good fit for this role?
                </TextRegular>

                <TextEditor
                  getter={coverSummary}
                  setter={setCoverSummary}
                  placeholder={'Copy and past the cover letter here.'}
                />
                <FormHelperText>{formError.coverSummary}</FormHelperText>
              </FormControl>
            </Grid>
          )}
          {type === 'candidateDetails' && (
            <>
              <Grid item xs={6} style={{ paddingRight: '8px' }}>
                <FormControl margin='normal' fullWidth>
                  <TextRegular style={{ color: theme.palette.text.secondary }}>
                    Candidate First Name
                  </TextRegular>
                  <TextField
                    fullWidth
                    value={candidateFirstName}
                    onChange={e => setCandidateFirstName(e.target.value)}
                    error={formError.candidateFirstName}
                    helperText={formError.candidateFirstName}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} style={{ paddingLeft: '8px' }}>
                <FormControl margin='normal' fullWidth>
                  <TextRegular style={{ color: theme.palette.text.secondary }}>
                    Candidate Last Name
                  </TextRegular>
                  <TextField
                    fullWidth
                    value={candidateLastName}
                    onChange={e => setCandidateLastName(e.target.value)}
                    error={formError.candidateLastName}
                    helperText={formError.candidateLastName}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} style={{ paddingRight: '8px' }}>
                <FormControl margin='normal' fullWidth>
                  <TextRegular style={{ color: theme.palette.text.secondary }}>
                    Candidate Phone Number
                  </TextRegular>
                  <TextField
                    fullWidth
                    value={candidatePhone}
                    onChange={e => {
                      const input = e.target.value.replace(/\D/g, '')
                      setCandidatePhone(input)
                    }}
                    error={formError.candidatePhone}
                    helperText={formError.candidatePhone}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} style={{ paddingLeft: '8px' }}>
                <FormControl margin='normal' fullWidth>
                  <TextRegular style={{ color: theme.palette.text.secondary }}>
                    Candidate Email
                  </TextRegular>
                  <TextField fullWidth value={item.candidateEmail} />
                </FormControl>
              </Grid>
              <Grid
                item
                xs={6}
                style={{ paddingRight: '8px', marginTop: '16px' }}
              >
                {item.resumePath && (
                  <Grid
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      border: `1px solid ${theme.palette.primary.main}`,
                      marginBottom: '10px',
                      borderRadius: '8px',
                      width: '100%'
                    }}
                  >
                    <Button
                      component='label'
                      role={undefined}
                      variant='text'
                      tabIndex={-1}
                      endIcon={<CloudUploadIcon />}
                      startIcon={<AttachFileIcon />}
                      style={{
                        textTransform: 'none',
                        width: 'fit-content',
                        padding: '12px 26px'
                      }}
                    >
                      {resume ? (
                        (resume && resume.name) ||
                        item?.candidateFirstName + '-Resume'
                      ) : (
                        <>
                          {item.candidateFirstName}
                          {item.candidateLastName}-Resume.
                          {item.resumePath.split('.').pop()}
                        </>
                      )}
                      <VisuallyHiddenInput
                        type='file'
                        accept='.pdf, .doc, .docx, .txt'
                        onChange={handleResumeChange}
                      />
                    </Button>
                  </Grid>
                )}
              </Grid>
              <Grid
                item
                xs={6}
                style={{ paddingLeft: '8px', marginTop: '16px' }}
              >
                {item.coverLetterPath && (
                  <Grid
                    item
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      paddingLeft: '8px',
                      border: `1px solid ${theme.palette.primary.main}`,
                      marginBottom: '10px',
                      borderRadius: '8px',
                      width: '100%'
                    }}
                  >
                    <Button
                      component='label'
                      role={undefined}
                      variant='text'
                      fullWidth
                      tabIndex={-1}
                      endIcon={<CloudUploadIcon />}
                      startIcon={<AttachFileIcon />}
                      style={{
                        textTransform: 'none',
                        width: 'fit-content',
                        padding: '12px 26px'
                      }}
                    >
                      {coverLetter ? (
                        (coverLetter && coverLetter.name) ||
                        item?.companyname + '-CoverLetter'
                      ) : (
                        <>
                          {item.companyname}-CoverLetter.
                          {item.resumePath.split('.').pop()}
                        </>
                      )}

                      <VisuallyHiddenInput
                        type='file'
                        accept='.pdf, .doc, .docx, .txt'
                        onChange={handleCoverLetterChange}
                      />
                    </Button>
                  </Grid>
                )}
              </Grid>
            </>
          )}
          {type === 'preScreen' && (
            <>
              {item?.preScreenQuestions?.map((que, index) => (
                <Grid
                  container
                  direction={'column'}
                  style={{ display: 'flex', flexDirection: 'row' }}
                  key={index}
                >
                  <Grid item xs={12} style={{ marginTop: '12px' }}>
                    <TextRegular>
                      {index + 1}. {que.question}
                    </TextRegular>
                  </Grid>

                  <Grid item xs={12}>
                    <TextRegular>
                      {que.type === 'textfield' && (
                        <TextField
                          placeholder='Answer'
                          fullWidth
                          value={que?.answer}
                          style={{ paddingRight: '10px' }}
                          onChange={e =>
                            handleAnswerChange(index, e.target.value)
                          }
                          error={
                            formError.hasOwnProperty('preScreenQues')
                              ? formError?.preScreenQues[index]?.answer
                              : false
                          }
                          helperText={
                            formError.hasOwnProperty('preScreenQues')
                              ? formError?.preScreenQues[index]?.answer
                              : ''
                          }
                        />
                      )}

                      {que.type === 'dropdown' && (
                        <FormControl
                          error={
                            formError.hasOwnProperty('preScreenQues')
                              ? formError?.preScreenQues[index]?.answer
                              : false
                          }
                          style={{ width: '100%' }}
                        >
                          <Select
                            labelId='demo-simple-select-label'
                            id='demo-simple-select'
                            value={que.answer}
                            onChange={e =>
                              handleAnswerChange(index, e.target.value)
                            }
                          >
                            {que?.options?.map((opt, index) => (
                              <MenuItem key={index} value={opt.name}>
                                {opt.name}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText>
                            {formError.hasOwnProperty('preScreenQues')
                              ? formError?.preScreenQues[index]?.answer
                              : ''}
                          </FormHelperText>
                        </FormControl>
                      )}

                      {que.type === 'radio' && (
                        <FormControl
                          error={
                            formError.hasOwnProperty('preScreenQues')
                              ? formError?.preScreenQues[index]?.answer
                              : false
                          }
                        >
                          <RadioGroup
                            row
                            name='row-radio-buttons-group'
                            onChange={e =>
                              handleAnswerChange(index, e.target.value)
                            }
                            value={que?.answer}
                          >
                            {que?.options?.map((opt, index) => (
                              <FormControlLabel
                                value={opt.name}
                                control={<Radio />}
                                label={opt.name}
                              />
                            ))}
                          </RadioGroup>
                          <FormHelperText>
                            {formError.hasOwnProperty('preScreenQues')
                              ? formError?.preScreenQues[index]?.answer
                              : ''}
                          </FormHelperText>
                        </FormControl>
                      )}

                      {que.type === 'checkbox' && (
                        <FormControl
                          component={'fieldset'}
                          error={
                            formError.hasOwnProperty('preScreenQues')
                              ? formError?.preScreenQues[index]?.answer
                              : false
                          }
                        >
                          <FormGroup>
                            {que?.options?.map((opt, oIndex) => {
                              var isChecked = que?.answer
                                ?.split('::')
                                ?.includes(opt.name)
                              return (
                                <FormControlLabel
                                  key={oIndex}
                                  control={
                                    <Checkbox
                                      value={opt.name}
                                      checked={isChecked}
                                      onChange={e => {
                                        var { value } = e.target
                                        if (isChecked) {
                                          var arr = que?.answer?.split('::')
                                          var i = arr?.findIndex(
                                            e => e == value
                                          )
                                          arr.splice(i, 1)
                                          value = arr.join('::')
                                        } else {
                                          if (
                                            que?.answer &&
                                            que?.answer !== ''
                                          ) {
                                            value = que?.answer + '::' + value
                                          }
                                        }
                                        handleAnswerChange(index, value)
                                      }}
                                      name={opt.name}
                                    />
                                  }
                                  label={opt.name}
                                />
                              )
                            })}
                          </FormGroup>
                          <FormHelperText>
                            {formError.hasOwnProperty('preScreenQues')
                              ? formError?.preScreenQues[index]?.answer
                              : ''}
                          </FormHelperText>
                        </FormControl>
                      )}
                    </TextRegular>
                  </Grid>
                </Grid>
              ))}
            </>
          )}
          {type === 'skills' && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginTop: '16px'
              }}
            >
              <FormControl fullWidth error={formError.skillRequired}>
                <Box
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    padding: '5px',
                    border: `1px solid ${theme.palette.border.main}`,
                    borderRadius: '5px',
                    width: '100%'
                  }}
                >
                  {skillRequired?.map((skill, index) => (
                    <Chip
                      key={index}
                      label={skill}
                      onDelete={() =>
                        setSkillRequired(
                          skillRequired.filter((_, i) => i !== index)
                        )
                      }
                      style={{
                        margin: '2px'
                      }}
                      sx={{
                        '& .MuiChip-deleteIcon': {
                          color: `${theme.palette.primary.main}`
                        }
                      }}
                    />
                  ))}
                  <TextField
                    placeholder='Press enter to enter multiple skills'
                    value={inputSkills}
                    onChange={e => setInputSkills(e.target.value)}
                    onKeyDownCapture={event => {
                      if (event.key === 'Enter') {
                        const trimmedSkills = inputSkills.trim()
                        if (trimmedSkills) {
                          setSkillRequired([...skillRequired, trimmedSkills])
                          setInputSkills('')
                        }
                      }
                    }}
                    InputProps={{
                      disableUnderline: true
                    }}
                    sx={{
                      width: '100%',
                      marginTop: '10px'
                    }}
                  />
                </Box>
                <FormHelperText>{formError.skillRequired}</FormHelperText>
              </FormControl>
            </div>
          )}
        </Grid>
        <Grid container style={{ display: 'flex' }}>
          <Grid item xs={2}>
            <AppButton
              variant='contained'
              name={'Update'}
              disabled={false}
              loading={loading}
              onClick={() => handleUpdate()}
              style={{
                marginTop: 10,
                padding: '12px 26px',
                borderRadius: '8px'
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <AppButton
              variant='text'
              name={'Cancel'}
              onClick={onClose}
              style={{
                marginTop: 10,
                padding: '12px 26px',
                borderRadius: '8px'
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  )
}
